// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V9F1BHwkEyENPST_BwNG {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.RiVHlYdOTBOqn1j_RKaF {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  min-width: 30vw;
}

.alx5yDtMgHRVRVqCvMxs {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.qFSXgQo18MNQ2PKDni51 {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.ra9MPegLHxqb3PTPnFaT {
  width: 80px;
  height: 80px;
}

.wC4tWCrGEfcBrKc6GnX9 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom: 1px solid #c4c4c4;
  padding: 8px 0;
}

.j_MhclL_dKLASRm36d0c {
  color: black;
  font-size: 16px;
  font-family: "Chakra Petch";
  font-weight: 400;
  cursor: pointer;
}
.j_MhclL_dKLASRm36d0c:hover {
  color: #48CAE4;
}

h5 {
  font-weight: bold;
}

.bVaVwurW_08M6LKaMl4k {
  color: black;
  font-size: 18px;
  font-family: "Chakra Petch";
  font-weight: 500;
}

.rT5wzWNofrh9nX3X7i_w {
  overflow-y: auto;
  max-height: 40vh;
  margin-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid #c4c4c4;
}

.A0xuSCFbsgG5mdCK7qOz {
  font-weight: bold;
}

.D7kjvtYx9o3_rWM2ywYk {
  font-weight: 300;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/screens/IdoCreateOrEdit/ViewParticipationModal.module.scss"],"names":[],"mappings":"AAAA;EACC,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;;AAEA;EACC,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AACD;;AAEA;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACD;;AAEA;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;AACD;;AAEA;EACC,aAAA;EACA,kCAAA;EACA,gCAAA;EACA,cAAA;AACD;;AAEA;EACC,YAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AACD;AAAC;EACC,cAAA;AAEF;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,YAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;AACD;;AAEA;EACC,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,gBAAA;EACA,eAAA;AACD","sourcesContent":[".editCadetOverlay {\r\n\tbackground-color: rgba(0, 0, 0, 0.6);\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.editCadetContainer {\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\tbackground-color: white;\r\n\tborder-radius: 8px;\r\n\tpadding: 20px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\trow-gap: 16px;\r\n\tmin-width: 30vw;\r\n}\r\n\r\n.editCadetFooter {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.userInfoRow {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.profileImage {\r\n\twidth: 80px;\r\n\theight: 80px;\r\n}\r\n\r\n.transactionRow {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 1fr 1fr 1fr;\r\n\tborder-bottom: 1px solid #c4c4c4;\r\n\tpadding: 8px 0;\r\n}\r\n\r\n.txIdCell {\r\n\tcolor: black;\r\n\tfont-size: 16px;\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-weight: 400;\r\n\tcursor: pointer;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n}\r\n\r\nh5 {\r\n\tfont-weight: bold;\r\n}\r\n\r\n.text {\r\n\tcolor: black;\r\n\tfont-size: 18px;\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-weight: 500;\r\n}\r\n\r\n.transactionContainer {\r\n\toverflow-y: auto;\r\n\tmax-height: 40vh;\r\n\tmargin-top: 16px;\r\n\tpadding-bottom: 16px;\r\n\tborder-top: 1px solid #c4c4c4;\r\n}\r\n\r\n.transactionHeaderCell {\r\n\tfont-weight: bold;\r\n}\r\n\r\n.transactionCell {\r\n\tfont-weight: 300;\r\n\tfont-size: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCadetOverlay": `V9F1BHwkEyENPST_BwNG`,
	"editCadetContainer": `RiVHlYdOTBOqn1j_RKaF`,
	"editCadetFooter": `alx5yDtMgHRVRVqCvMxs`,
	"userInfoRow": `qFSXgQo18MNQ2PKDni51`,
	"profileImage": `ra9MPegLHxqb3PTPnFaT`,
	"transactionRow": `wC4tWCrGEfcBrKc6GnX9`,
	"txIdCell": `j_MhclL_dKLASRm36d0c`,
	"text": `bVaVwurW_08M6LKaMl4k`,
	"transactionContainer": `rT5wzWNofrh9nX3X7i_w`,
	"transactionHeaderCell": `A0xuSCFbsgG5mdCK7qOz`,
	"transactionCell": `D7kjvtYx9o3_rWM2ywYk`
};
export default ___CSS_LOADER_EXPORT___;
